module.exports = __webpack_public_path__ + "img/meixinghao.ebc5b9bf.gif";